import createReactComponent from '../createReactComponent';
export default createReactComponent('stack-3', 'IconStack3', [
  ['path', { d: 'M12 2l-8 4l8 4l8 -4l-8 -4', key: 'svg-0' }],
  ['path', { d: 'M4 10l8 4l8 -4', key: 'svg-1' }],
  ['path', { d: 'M4 18l8 4l8 -4', key: 'svg-2' }],
  ['path', { d: 'M4 14l8 4l8 -4', key: 'svg-3' }],
]);
